import { render } from "./AnagraficaLeadCaldi.vue?vue&type=template&id=2db707c2&scoped=true"
import script from "./AnagraficaLeadCaldi.vue?vue&type=script&lang=js"
export * from "./AnagraficaLeadCaldi.vue?vue&type=script&lang=js"

import "./AnagraficaLeadCaldi.vue?vue&type=style&index=0&id=2db707c2&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db707c2"]])

export default __exports__